import React from 'react';
import PriceFilter from '../PriceFilter';
import BedroomFilter from '../BedroomFilter';
import BuildingStatusFilters from '../BuildingStatusFilters';
import ExpectedMoveInDateFilter from '../ExpectedMoveInDateFilter';
import { FilterKey, FilterVariantProps } from '../shared/types';
import { BUILDING_STATUS_FILTER_MAPPING } from '../shared/constants';

export function useFilterComponents(variant: 'desktop' | 'mobile' = 'desktop') {
  const getFilterComponent = (key: FilterKey, props?: Partial<FilterVariantProps>) => {
    const baseProps = {
      variant,
      requireConfirmation: true,
      ...props,
    };

    switch (key) {
      case 'price': {
        const priceProps = { ...baseProps };
        if (variant === 'desktop') {
          priceProps.className = 'p-6 w-sm rounded-3xl bg-primary border border-tertiary shadow-lg';
        }
        return React.createElement(PriceFilter, priceProps);
      }

      case 'beds': {
        const bedroomProps = {
          showLabel: false,
          ...baseProps,
        };
        if (variant === 'desktop') {
          bedroomProps.className =
            'p-6 w-full rounded-3xl bg-primary border border-tertiary shadow-lg';
        } else {
          bedroomProps.className = 'p-6 rounded-3xl bg-primary border border-tertiary shadow-lg';
        }
        return React.createElement(BedroomFilter, bedroomProps);
      }

      case 'verified':
      case 'topRated':
      case 'rentStabilized':
      case 'goodCause': {
        const filterType = BUILDING_STATUS_FILTER_MAPPING[key];
        if (!filterType) return null;

        const buildingStatusProps = {
          filterType,
          ...baseProps,
        };
        if (variant === 'desktop') {
          buildingStatusProps.className =
            'w-sm p-6 rounded-3xl bg-primary border border-tertiary shadow-lg';
        }
        return React.createElement(BuildingStatusFilters, buildingStatusProps);
      }

      case 'moveInDate': {
        const moveInDateProps = {
          showLabel: false,
          ...baseProps,
        };
        if (variant === 'desktop') {
          moveInDateProps.className =
            'w-sm p-6 rounded-3xl bg-primary border border-tertiary shadow-lg';
        }
        return React.createElement(ExpectedMoveInDateFilter, moveInDateProps);
      }

      default:
        return null;
    }
  };

  return { getFilterComponent };
}
